import React from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { CustomerActFRegisItemStyled } from "./styled";
import { RENDER_ACITIVITY_FORM_STATUS } from "utils/functions/activityForm";
import { useTranslation } from "react-i18next";
import { Icons } from "components";

const CustomerActFRegisItem = ({
  theme_standard,
  // certificate_file,
  certificate_generate_history_ref_id,
  check_in,
  no,
  personal_first_name,
  personal_last_name,
  status,
  isClosedRegistration,
  is_qrcode,
  is_edit_request_active,
  onApproveAdminEdit,
  onEdit,
  onShowQrCode,
  onDelete,
  onEditDataRequest,
  onResumeEdit,
  onView,
}) => {
  const customClass = cx({
    theme_standard: theme_standard,
  });

  const { t } = useTranslation(["common"]);

  const renderStatus = RENDER_ACITIVITY_FORM_STATUS(status);
  return (
    <CustomerActFRegisItemStyled
      className={customClass}
      statusBg={renderStatus.bgColor}
      statusTxtBg={renderStatus.txtColor}
    >
      <div className="cus_info_block">
        <div className="mbr_name">
          {no} {personal_first_name} {personal_last_name}
        </div>
        {status !== "5" && (
          <button className="btn_view_detail" onClick={onView}>
            View Detail
          </button>
        )}
      </div>
      <div className="mbr_status_info_row">
        <div className="status_title">Status:</div>
        <div className="mrt_col">
          <button className="mbr_status">{renderStatus.label}</button>
        </div>
      </div>
      <div className="mbr_status_info_row mb_0">
        {is_edit_request_active && (status === "4" || status === "6") && (
          <div className="mrt_col mw_half">
            <button className="si_item bg_purple" onClick={onEditDataRequest}>
              ขอแก้ไขข้อมูล
            </button>
          </div>
        )}
        {status === "7" && (
          <div className="mrt_col mw_half">
            <button className="si_item bg_purple" onClick={onApproveAdminEdit}>
              ตรวจเช็คข้อมูล
            </button>
          </div>
        )}
        <div className="mrt_col mw_half">
          {is_qrcode &&
            status === "4" &&
            (!check_in ? (
              <button className="si_item bg_blue" onClick={onShowQrCode}>
                <Icons.QrCodeMark />
                ID QR code
              </button>
            ) : (
              <button className="si_item check_in_label">Check in</button>
            ))}
          {status === "0" && (
            <button className="si_item bg_purple fade" onClick={onDelete}>
              {t("Delete", { ns: "common" })}
            </button>
          )}
        </div>
        {(status === "0" ||
          status === "5" ||
          status === "1" ||
          status === "2" ||
          certificate_generate_history_ref_id) && (
          <div className="mrt_col mw_half">
            {status === "0" && (
              <button className="si_item bg_purple" onClick={onResumeEdit}>
                {t("Resume Registration", { ns: "common" })}
              </button>
            )}
            {!isClosedRegistration &&
              (status === "5" || status === "1" || status === "2") &&
              !certificate_generate_history_ref_id && (
                <button className="si_item bg_purple" onClick={onEdit}>
                  {t("Edit", { ns: "common" })}
                </button>
              )}
            {certificate_generate_history_ref_id && (
              <div className="cert_generate">{"Cerification\n via Email"}</div>
            )}
          </div>
        )}
      </div>
      {(status === "7" || status === "2") && (
        <div className="mark_block">
          {status === "7" && (
            <div className="mark_label">
              * เลือก “ตรวจเช็กข้อมูล” เพื่อเข้าไปยืนยันว่าข้อมูลที่แก้ไขถูกต้อง
              หากท่านไม่เข้าไปตรวจเช็กและยืนยัน
              จะถือว่าข้อมูลที่แก้ไขถูกต้องทั้งหมด
            </div>
          )}
          {status === "2" && (
            <div className="mark_label">
              * มีข้อมูลไม่ถูกต้อง กรุณาเลือก “ตรวจเช็กข้อมูล”
              เพื่อเข้าไปแก้ไขอีกครั้ง หากท่านไม่เข้าไปแก้ไข
              จะถือว่าข้อมูลที่ส่งรายการก่อนหน้านั้นถูกต้องทั้งหมด
            </div>
          )}
        </div>
      )}
    </CustomerActFRegisItemStyled>
  );
};

CustomerActFRegisItem.propTypes = {};

export default CustomerActFRegisItem;
